import React from "react";
import ReuseModal from "../../../components/fragment/modal/ReuseModal";
import "../../../styles/dashboard/transaction/transactionIndex.css";
import {
  RazorBadgeTwo,
  RazorCopyText,
  RazorDateTime,
  RazorToolTip,
  RazorTextTrim,
  RazorNumberFormat,
  RazorGetValue,
} from "../../../components/razor-reuse";
import ExchangeCurrencyText from "../../../components/fragment/cur-text/ExchangeCurrencyText";

interface myComponentProps {
  onClose?: () => void;
  onFinish?: () => void;
  visible?: boolean;
  details?: any;
}

const TransactionModal = ({ onClose, visible, details }: myComponentProps) => {
  const objListToView = [
    {
      key: "sender",
      label: "Sender's Name",
      value: `${details?.sender?.first_name} ${details?.sender?.last_name}`,
    },
    { key: "recipient_name", label: "Receipient’s Name", value: "" },
    { key: "recipient_email", label: "Recipient Email", value: "" },
    { key: "recipient_bank", label: "Recipient Bank", value: "" },
    { key: "recipient_account", label: "Recipient Account Num.", value: "" },
    {
      key: "amount",
      label: "Amount:",
      value: "",
      amount: true,
      symbol: details?.source_currency?.code,
    },
    { key: "tx_reference", label: "Transaction Ref", value: "", copy: true },
    { key: "created_at", label: "Transaction Date", value: "", date: true },
    {
      key: "exchange_rate",
      label: "Exchange Rate",
      value: "",
      amount: true,
      symbol: "NGN",
    },
    {
      key: "credit_amount",
      label: "Credit Amount",
      value: "",
      amount: true,
      symbol: details?.destination_currency?.code || "NIL",
    },
    { key: "service_charge", label: "Service Charge", value: "", amount: true },
    { key: "total_amount", label: "Total Amount", value: "" },
    {
      key: "sender",
      label: "Currency Type",
      value: (
        <ExchangeCurrencyText
          curOne={details?.source_currency?.code || "NIL"}
          curTwo={details?.destination_currency?.code || "NIL"}
          urlOne={""}
          urlTwo={""}
        />
      ),
    },
    // { key: "sender", label: "Phone Number", value: "+1 1234 567 892" },
    {
      key: "sender",
      label: "Status:",
      value: (
        <RazorBadgeTwo
          className={
            details?.status === "failed"
              ? "failed"
              : details?.status === "successful"
              ? "success"
              : details?.status === "completed"
              ? "success"
              : details?.status === "pending"
              ? "pending"
              : details?.status === "processing"
              ? "pending"
              : details?.status === "submitted"
              ? "pending"
              : ""
          }
          text={details?.status}
        />
      ),
    },
  ];

  return (
    <>
      <ReuseModal
        title="Transaction Overview"
        visible={visible}
        onClose={onClose}
        hideBtn
        titleBtnlabel="Generate Receipt"
        onTitleBtnClick={() => {}}
      >
        <div className="transaction-modal-box-wrapper !-mt-9 !overflow-y-auto">
          {/* <p className="title-view">Transaction Details</p> */}
          {/* wrapper start */}
          <div className="label-value-box-wrap">
            {RazorGetValue(objListToView, details)?.map((chi: any, idx) => {
              if (chi?.hide || !chi?.value) {
                return <React.Fragment key={idx}></React.Fragment>;
              }
              return (
                <div key={idx} className="label-value-box">
                  <p className="label">{chi?.label}:</p>
                  <div
                    className={`value ${
                      String(chi?.value)?.length > 25 && !chi?.date
                        ? "tooltip-hover-wrap"
                        : ""
                    }`}
                    style={{ color: chi?.color ? chi?.color : "" }}
                  >
                    {chi?.date ? (
                      <RazorDateTime date={chi?.value} hideAgo />
                    ) : chi?.amount ? (
                      chi?.copy ? (
                        <RazorCopyText
                          textToCopy={RazorNumberFormat(chi?.value, {
                            symbol: chi?.symbol,
                            numberAbbreviate: String(chi?.value)?.length > 8,
                          })}
                          reference={RazorNumberFormat(chi?.value, {
                            symbol: chi?.symbol,
                            numberAbbreviate: String(chi?.value)?.length > 8,
                          })}
                          outerCopy
                        />
                      ) : (
                        RazorNumberFormat(chi?.value, {
                          symbol: chi?.symbol,
                          numberAbbreviate: String(chi?.value)?.length > 8,
                        })
                      )
                    ) : chi?.copy ? (
                      <RazorCopyText
                        textToCopy={chi?.value}
                        reference={RazorTextTrim(chi?.value, 25)}
                        outerCopy
                      />
                    ) : (
                      RazorTextTrim(chi?.value, 25) || "---"
                    )}
                    <RazorToolTip
                      color="black-light"
                      text={chi?.value}
                      position={`top-center`}
                    />
                  </div>
                </div>
              );
            })}
            {/* label-value box start  */}
            {/* <div className="label-value-box">
              <p className="label">Sender’s Name:</p>
              <p className="value">Cassandra Onyenjen</p>
            </div> */}
            {/* label-value box end */}

            {/* <RazorPreviewBox list={RazorGetValue(objListToView, '')} /> */}
          </div>
          {/* wrapper send */}
        </div>
      </ReuseModal>
    </>
  );
};

export default TransactionModal;
